/*
|--------------------------------------------------------------------------
| Utilities: Tracker
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.utilities.tracker = {
	"init": function() {
		var currentPage 	= __gh__webApp.currentPage,
			commonJS		= __gh__webApp.common,
			googleAnalytics = __gh__webApp.analytics.google,
			url				= document.location.href,
			urlref			= document.referrer,
			siteData 		= __gh__coreData.siteData;

		if (!commonJS.isObjectPropertySet(siteData,"providers.analytics.google")){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.tracker",message:"Google analytics not set in siteData > providers > analytics > google."});
			return;
		}
		__gh__webApp.analytics.google = googleAnalytics[siteData.providers.analytics.google];
		__gh__webApp.analytics.google.init();
		__gh__webApp.analytics.parsely.track({"url":url,"urlref":urlref});
	},


	/**
	 * Article tracking
	 */
	"trackArticle": {

		/**
		 * Main tracking function used for tracking an article page
		 * @param {object} options
		 * @param {object} options.articleObject - article json object
		 */
		"main": function(options){
			var thisTracker 	= __gh__webApp.utilities.tracker,
				commonJS		= __gh__webApp.common,
				articleObject	= ("articleObject" in options) ? options.articleObject : null,
				articlePath		= (articleObject && commonJS.isObjectPropertySet(articleObject,"track.articlePath")) ? articleObject.track.articlePath : null,
				articleTitle	= (articleObject && commonJS.isObjectPropertySet(articleObject,"title")) ? articleObject.title : null;

				if (!articlePath){
					__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.trackArticle.main",message:"Missing articlePath."});
					return;
				}
				
				thisTracker.trackPage({"path": articlePath,"title":articleTitle});
				//thisTracker.trackArticle.author(articleObject);
		},
		
		/**
		 * Tracks anytime an article is loaded (both read more articles and main article)
		 * @param {object} options
		 * @param {object} options.articleObject - article json object
		 */
		"allArticlesOnLoad": function(options){
			var trackArticle 	= __gh__webApp.utilities.tracker.trackArticle,
				commonJS		= __gh__webApp.common,
				analytics		= __gh__webApp.analytics,
				articleObject	= ("articleObject" in options) ? options.articleObject : null;
			
			analytics.salesforce.trackArticle(articleObject);
		},
		
		
		/**
		 * Tracking specific to the main article loading
		 */
		"mainArticle": function(options){
			/*var thisTracker 	= __gh__webApp.utilities.tracker;
				articleObject	= ("articleObject" in options) ? options.articleObject : null;
				//thisTracker.trackArticle.author(articleObject)*/
		},
		
		
		/**
		 * Tracking specific to the when someone clicks a read more card and it shows the full article
		 */
		"readMoreFullArticle": function(options){
			var trackArticle 	= __gh__webApp.utilities.tracker.trackArticle,
				articleObject	= ("articleObject" in options) ? options.articleObject : null;
				
				trackArticle.main({"articleObject":articleObject});
		},


		/**
		 * Track only author
		 * @param {object} options
		 * @param {object} options.articleObject - article json object
		 */
		"author": function(options){
			var thisTracker 	= __gh__webApp.utilities.tracker,
				commonJS		= __gh__webApp.common,
				articleObject	= ("articleObject" in options) ? options.articleObject : null;
				authorPath 		= (articleObject && commonJS.isObjectPropertySet(articleObject,"track.authorPath")) ? options.authorPath : null;
				if (!authorPath){
					__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.trackArticle.author",message:"Missing author path."});
					return;
				}
				setTimeout(function() {
				  thisTracker.trackEvent({"category":authorPath});
				}, 1000);
		},


		/**
		 * Track article pagination
		 * @param {object} options
		 * @param {string} options.articlePath - url path for article
		 * @param {string} options.authorPath - url path for author
		 * @param {string} options.articleTitle - title of the Article
		 * @param {number} options.pageNumber - page number for the article
		 */
		"pagination": function(options){
			var thisTracker 	= __gh__webApp.utilities.tracker,
				commonJS			= __gh__webApp.common,
				articleObject		= ("articleObject" in options) ? options.articleObject : null,
				articlePath			= (articleObject && commonJS.isObjectPropertySet(articleObject,"track.articlePath")) ? articleObject.track.articlePath : null,
				articleTitle		= (articleObject && commonJS.isObjectPropertySet(articleObject,"title")) ? articleObject.title : null;
				pageNumber			= ("pageNumber" in options) ? options.pageNumber : null,
				paginationPath 		= articlePath +"/pagination/"+pageNumber;

				if (!articlePath){
					__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.trackArticle.author",message:"Missing articlePath."});
					return;
				}

				if (!pageNumber){
					__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.trackArticle.author",message:"Missing pageNumber."});
					return;
				}

				thisTracker.trackPage({"path": paginationPath,"title":articleTitle});
		},


		/**
		 * Track article read more clicks
		 */
		"readMoreClick": function(options){
			var thisTracker = __gh__webApp.utilities.tracker;
			thisTracker.trackEvent(options);
		}
	},


	/**
	 * Track an event
	 */
	"trackEvent": function(options){
		var googleAnalytics = __gh__webApp.analytics.google;
			googleAnalytics.trackEvent(options);

	},


	/**
	 * Track a photo gallery
	 * @param {string} path - path for gallery
	 */
	"trackGallery": function(options){
		var currentPage			= __gh__webApp.currentPage,
			googleAnalytics 	= __gh__webApp.analytics.google,
			parsely 			= __gh__webApp.analytics.parsely,
			defaultURL			= location.protocol + '//' + location.host + location.pathname,
			imageURL 			= ("imageURL" in options) ? options.imageURL : defaultURL,
			galleryURL 			= ("galleryURL" in options) ? options.galleryURL : defaultURL,
			parselyGalleryURL	= (currentPage.isArticle()) ? defaultURL : galleryURL,
			urlref				= document.referrer;
	
			googleAnalytics.trackPage({"url": imageURL});
			parsely.track({"url":parselyGalleryURL,"urlref":urlref});
	},
	
	/**
	 * Track Infinite Scroll
	 */
	"trackInfiniteScroll": function(options){
		var thisTracker 		= __gh__webApp.utilities.tracker,
			pageTitle			= ("title" in options) ? options.title : null;
			
		thisTracker.trackURL({"title":pageTitle});
	},
	


	/**
	 * Track a page
	 * @param {object} options
	 * @param {string} options.path - path portion of url (ie "/url-path")
	 * @param {string} [options.title=null] - title
	 */
	"trackPage": function(options){
		var googleAnalytics 	= __gh__webApp.analytics.google,
			path 				= ("path" in options) 	? options.path : location.protocol + '//' + location.host + location.pathname,
			title 				= ("title" in options) 	? options.title : null,
			parsely 			= __gh__webApp.analytics.parsely,
			urlref				= document.referrer;

		googleAnalytics.trackPage({"path": path,"title": title});
		parsely.track({"url":path,"urlref":urlref});
	},
	
	
	/**
	 * Track Pagination
	 */
	"trackPagination": function(options){
		var thisTracker 		= __gh__webApp.utilities.tracker,
			pageTitle			= ("title" in options) ? options.title : document.title;
			
		thisTracker.trackURL({"title":pageTitle});
	},
	
	
	/**
	 * Track Search
	 */
	"trackSearch": {
		
		/**
		 * Track each time search results are loaded (includes pagination, filtering ect)
		 * @param {object} options
		 * @param {string} options.searchText - text that was searched for
		 */
		"loadSearchResults": function(options){
			var thisTracker = __gh__webApp.utilities.tracker,
				analytics	= __gh__webApp.analytics,
				searchText 	= ("searchText" in options) ? options.searchText : null;
			
			thisTracker.trackURL();
			analytics.salesforce.trackSearch(searchText);
			
		}
		
	},
	
	
	/**
	 * Track Newsletter Sign Up
	 * @param {object} options
	 * @param {string} options.email - email address
	 */
	 "trackNewsletterSignUp": function(options){
		 var analytics	= __gh__webApp.analytics,
			 email 	= ("email" in options) ? options.email : null;
		
		analytics.salesforce.trackNewsletterSignUp(email);
	 },


	/**
	 * Track social stuff
	 */
	"trackSocial":{
		
		/**
		 * Track social buttons
		 */
		"shareButtonClick":function(data){
			var analytics = __gh__webApp.analytics;
				analytics.salesforce.trackSocial(data);
		},
	},

	/**
	 * Track Tout video
	 */
	"trackToutVideo": function(options){
		//var googleAnalytics = __gh__webApp.analytics.google;
	},


	/**
	 * Track a url
	 * @param {object} options
	 * @param {string} options.url - full url or url path, it'll be converted to a path
	 * @param {string} [options.title=null] - title
	 */
	"trackURL": function(options){
		var googleAnalytics = __gh__webApp.analytics.google,
			commonJS		= __gh__webApp.common,
			options 		= options || {},
			url				= ("url" in options) 	? options.url 	: document.location.href,
			urlPath 		= commonJS.getURLPath(url),
			title			= ("title" in options) 	? options.title : document.title;
			parsely 		= __gh__webApp.analytics.parsely,
			urlref			= document.referrer;

			googleAnalytics.trackPage({"path": urlPath,"title": title});
			parsely.track({"url":urlPath,"urlref":urlref});
	},


	/**
	 * Bind Events
	 */
	"bindEvents": function(){

		var thisTracker = this;

		//Track Event
		$(document).on('click','[data-gh-tracker-track-event-object]',function(){
			var trackerObject = $(this).data("gh-tracker-track-event-object");
				thisTracker.trackEvent({
					'path'				: trackerObject.path,
					'action'			: trackerObject.action,
					"label"				: trackerObject.label,
					"value"				: trackerObject.value,
					"nonInteraction"	: trackerObject.nonInteraction
				});
		});

		//Track Page
		$(document).on('click','[data-gh-analytics-track-page-path]',function(){
			var trackerObject = $(this).data("gh-tracker-track-page-object")
				thisTracker.trackPage({
					'path'				: trackerObject.path,
					'title'				: trackerObject.title
				});
		});
	}
};